import styled from 'styled-components';

export const StyledSwiper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    color: 'var(--color-primary-blue)';
    opacity: 0.7;
  }
`;
